import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeferredJsonMerger16i62uujz1qml as DeferredJsonMerger } from '../../internal/DeferredJsonMerger.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
} from '../../internal/multipart.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
} from './HttpInterceptor.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { emitAll14ajoawrvg9d0 as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
function HttpNetworkTransport$execute$slambda$o$collect$slambda() {
  if (HttpNetworkTransport$execute$slambda$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
        this.i69_1 = $$this$unsafeFlow;
        this.j69_1 = this$0;
        this.k69_1 = $request;
        this.l69_1 = $httpResponse;
        this.m69_1 = $millisStart;
      }
      *o1h(value, $completion) {
        var $this$transform = this.i69_1;
        var tmp$ret$1 = withHttpInfo(this.j69_1, value, this.k69_1.j43_1, this.l69_1, this.m69_1);
        yield* $this$transform.h1d(tmp$ret$1, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambda$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
}
function HttpNetworkTransport$execute$slambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  var i = new (HttpNetworkTransport$execute$slambda$o$collect$slambda())($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$execute$2$$inlined$map$1Class;
function HttpNetworkTransport$execute$2$$inlined$map$1() {
  if (HttpNetworkTransport$execute$2$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.n69_1 = $this;
        this.o69_1 = this$0;
        this.p69_1 = $request;
        this.q69_1 = $httpResponse;
        this.r69_1 = $millisStart;
      }
      *g1d(collector, $completion) {
        var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda_0(collector, this.o69_1, this.p69_1, this.q69_1, this.r69_1);
        yield* this.n69_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$2$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$2$$inlined$map$1Class;
}
var HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
function HttpNetworkTransport$multipleResponses$o$collect$slambda() {
  if (HttpNetworkTransport$multipleResponses$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.s69_1 = $$this$unsafeFlow;
        this.t69_1 = $operation;
        this.u69_1 = $customScalarAdapters;
        this.v69_1 = this$0;
        this.w69_1 = $jsonMerger;
      }
      *o1h(value, $completion) {
        var tmp0 = this.s69_1;
        $l$block: {
          var tmp;
          var tmp_0 = this.t69_1;
          if (isInterface(tmp_0, Subscription())) {
            var reader = jsonReader_0(value);
            var payloadResponse = null;
            var errors = null;
            reader.f41();
            while (reader.q1()) {
              switch (reader.h41()) {
                case 'payload':
                  if (reader.i40().equals(Token_NULL_getInstance())) {
                    reader.h40();
                  } else {
                    payloadResponse = parseResponse(reader, this.t69_1, VOID, this.u69_1, null);
                  }

                  break;
                case 'errors':
                  if (reader.i40().equals(Token_NULL_getInstance())) {
                    reader.h40();
                  } else {
                    errors = readErrors(reader);
                  }

                  break;
                default:
                  reader.h40();
                  break;
              }
            }
            reader.g41();
            var tmp_1;
            if (!(errors == null)) {
              tmp_1 = errorResponse(this.v69_1, this.t69_1, RouterError().w4d(errors));
            } else if (!(payloadResponse == null)) {
              tmp_1 = payloadResponse;
            } else {
              tmp_1 = null;
            }
            tmp = tmp_1;
          } else {
            if (this.w69_1._v == null) {
              this.w69_1._v = new (DeferredJsonMerger())();
            }
            var merged = this.w69_1._v.p67(value);
            var deferredFragmentIds = this.w69_1._v.m67_1;
            var isLast = !this.w69_1._v.n67_1;
            var tmp_2;
            if (this.w69_1._v.o67_1) {
              tmp_2 = null;
            } else {
              tmp_2 = toApolloResponse(jsonReader(merged), this.t69_1, VOID, this.u69_1, deferredFragmentIds).v43().n44(isLast).p37();
            }
            tmp = tmp_2;
          }
          var tmp0_elvis_lhs = tmp;
          var tmp_3;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp_3 = tmp0_elvis_lhs;
          }
          var transformed = tmp_3;
          yield* tmp0.h1d(transformed, $completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda_0($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
  var i = new (HttpNetworkTransport$multipleResponses$o$collect$slambda())($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().t47('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().g44(operation, tmp0_requestUuid).l44(apolloException).n44(true).p37();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.a6a_1) {
    tmp = httpResponse.t49();
  } else {
    var tmp0_safe_receiver = httpResponse.t49();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.l6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().q4d(httpResponse.p49_1, httpResponse.q49_1, maybeBody, 'Http request failed with status code `' + httpResponse.p49_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, operation, customScalarAdapters, httpResponse) {
  var response = toApolloResponse(jsonReader_0(ensureNotNull(httpResponse.t49())), operation, VOID, customScalarAdapters, null);
  return flowOf(response.v43().n44(true).p37());
}
function multipleResponses($this, operation, customScalarAdapters, httpResponse) {
  var jsonMerger = {_v: null};
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, customScalarAdapters, $this, jsonMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda_0(operation, $this));
}
function wrapIfNeeded($this, $receiver) {
  var tmp;
  if ($receiver instanceof ApolloException()) {
    tmp = $receiver;
  } else {
    tmp = ApolloNetworkException().t47('Error while reading response', $receiver);
  }
  return tmp;
}
function withHttpInfo($this, $receiver, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = $receiver.v43().v42(requestUuid);
  if (!(httpResponse == null)) {
    this_0.h44(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.p49_1, httpResponse.q49_1));
  }
  return this_0.p37();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.c6a_1 = $outer;
      }
      *e69(request, chain, $completion) {
        return yield* this.c6a_1.y69_1.z68(request, $completion);
      }
    }
    protoOf($).jz = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.r65_1 = null;
        this.s65_1 = null;
        this.t65_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.u65_1 = ArrayList().p2();
        this.v65_1 = false;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.w65_1 = ArrayList().p2();
      }
      s64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.s65_1 = serverUrl;
        return this;
      }
      y65(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.v65_1 = exposeErrorBody;
        return this;
      }
      x65(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.t65_1 = httpEngine;
        return this;
      }
      z65(interceptors) {
        // Inline function 'kotlin.apply' call
        this.u65_1.a5();
        this.u65_1.u2(interceptors);
        return this;
      }
      p37() {
        // Inline function 'kotlin.check' call
        if (!(this.r65_1 == null || this.s65_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.r65_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.s65_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = new (DefaultHttpRequestComposer())(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message_0 = "No HttpRequestComposer found. Use 'httpRequestComposer' or 'serverUrl'";
          throw IllegalStateException().o(toString(message_0));
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var composer = tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.w65_1.n1()) {
          this.u65_1.i2(new (TransportHeadersInterceptor())(this.w65_1));
        }
        var tmp3_elvis_lhs = this.t65_1;
        return new (HttpNetworkTransport())(composer, tmp3_elvis_lhs == null ? DefaultHttpEngine() : tmp3_elvis_lhs, this.u65_1, this.v65_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.d6a_1 = headers;
      }
      *e69(request, chain, $completion) {
        return yield* chain.h69(request.a4a().a49(this.d6a_1).p37(), $completion);
      }
    }
    protoOf($).jz = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.e6a_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.e6a_1(value, $completion);
      }
      i5() {
        return this.e6a_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.f6a_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.f6a_1(value, $completion);
      }
      i5() {
        return this.f6a_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$slambdaClass;
function HttpNetworkTransport$execute$slambda() {
  if (HttpNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $httpRequest, $request, $customScalarAdapters) {
        this.g6a_1 = this$0;
        this.h6a_1 = $httpRequest;
        this.i6a_1 = $request;
        this.j6a_1 = $customScalarAdapters;
      }
      *y66($this$flow, $completion) {
        var millisStart = currentTimeMillis();
        var throwable = null;
        var tmp;
        try {
          tmp = yield* (new (DefaultHttpInterceptorChain())(plus(this.g6a_1.z69_1, this.g6a_1.b6a_1), 0)).h69(this.h6a_1, $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var t = $p;
            if (t instanceof CancellationException()) {
              throw t;
            }
            throwable = t;
            tmp_0 = null;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var httpResponse = tmp;
        var tmp_1;
        if (httpResponse == null) {
          tmp_1 = flowOf(errorResponse(this.g6a_1, this.i6a_1.i43_1, ensureNotNull(throwable)));
        } else {
          var tmp_2;
          var containsArg = httpResponse.p49_1;
          if (!(200 <= containsArg ? containsArg <= 299 : false)) {
            tmp_2 = !get_isGraphQLResponse(httpResponse);
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp_1 = errorResponse_0(this.g6a_1, this.i6a_1.i43_1, httpResponse);
          } else {
            if (get_isMultipart(httpResponse)) {
              tmp_1 = multipleResponses(this.g6a_1, this.i6a_1.i43_1, this.j6a_1, httpResponse);
            } else {
              tmp_1 = singleResponse(this.g6a_1, this.i6a_1.i43_1, this.j6a_1, httpResponse);
            }
          }
        }
        var responses = tmp_1;
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp$ret$0 = new (HttpNetworkTransport$execute$2$$inlined$map$1())(responses, this.g6a_1, this.i6a_1, httpResponse, millisStart);
        yield* emitAll($this$flow, tmp$ret$0, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.y66((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambdaClass;
}
function HttpNetworkTransport$execute$slambda_0(this$0, $httpRequest, $request, $customScalarAdapters) {
  var i = new (HttpNetworkTransport$execute$slambda())(this$0, $httpRequest, $request, $customScalarAdapters);
  var l = ($this$flow, $completion) => i.y66($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.k6a_1 = $this;
        this.l6a_1 = $operation;
        this.m6a_1 = $customScalarAdapters;
        this.n6a_1 = this$0;
        this.o6a_1 = $jsonMerger;
      }
      *g1d(collector, $completion) {
        var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda_0(collector, this.l6a_1, this.m6a_1, this.n6a_1, this.o6a_1);
        yield* this.k6a_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
var HttpNetworkTransport$multipleResponses$slambdaClass;
function HttpNetworkTransport$multipleResponses$slambda() {
  if (HttpNetworkTransport$multipleResponses$slambdaClass === VOID) {
    class $ {
      constructor($operation, this$0) {
        this.p6a_1 = $operation;
        this.q6a_1 = this$0;
      }
      *r6a($this$catch, throwable, $completion) {
        yield* $this$catch.h1d(Builder().g44(this.p6a_1, uuid4()).l44(wrapIfNeeded(this.q6a_1, throwable)).p37(), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.r6a(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpNetworkTransport$multipleResponses$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$slambda_0($operation, this$0) {
  var i = new (HttpNetworkTransport$multipleResponses$slambda())($operation, this$0);
  var l = ($this$catch, throwable, $completion) => i.r6a($this$catch, throwable, $completion);
  l.$arity = 2;
  return l;
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody) {
        this.x69_1 = httpRequestComposer;
        this.y69_1 = engine;
        this.z69_1 = interceptors;
        this.a6a_1 = exposeErrorBody;
        this.b6a_1 = new (EngineInterceptor())(this);
      }
      t66(request) {
        var customScalarAdapters = ensureNotNull(request.k43_1.r46(Key_getInstance()));
        var httpRequest = this.x69_1.s48(request);
        return this.s6a(request, httpRequest, customScalarAdapters);
      }
      s6a(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda_0(this, httpRequest, request, customScalarAdapters));
      }
      jz() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.z69_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          element.jz();
        }
        this.y69_1.l6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
